import { GetListBase } from "../client-parent/client-parent.model";

export class ClientEmployeeContactBO {
    Id: string;
    ContactType: string
    type: string
    Relationtype:string="Contacts";
}

export class ContactInfoLst {
    id: string = "00000000-0000-0000-0000-000000000000";
    contactTypeLid: string;
    contactType_Lov: string;
    relationshipLid: string | null;
    relationship_Lov: string;
    phoneCarrierLid: string | null;
    phoneCarrier_Lov: string;
    employeeId: string;
    employeeName: string;
    agencyId: string;
    name: string;
    clientId: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    county: string;
    clientName: string;
    phoneNumber: string;
    alternatePhoneNumber: string;
    fax: string;
    email: string;
    showAdditionalDetails: boolean = false;
    clinic: string;
}

export class functionpermissionemployee {
    employeecreate: boolean = true;
    employeeupdate: boolean = true;
    payorrequiredcreate: boolean = true;
    payorrequireddelete: boolean = true;
    payorrequiredupdate: boolean = true;
    payratescreate: boolean = true;
    payratesdelete: boolean = true;
    payratesupdate: boolean = true;
    payrollinfocreate: boolean = true
    payrollinfoupdate: boolean = true
    payrollinfosave: boolean = true
    employeenotescreate: boolean = true
    employeenotesupdate: boolean = true
    employeenotesdelete: boolean = true
    payratecreate: boolean = true
    payrateupdate: boolean = true
    payratedelete: boolean = true
    contactcreate: boolean = true;
    contactupdate: boolean = true;
    contactdelete: boolean = true;
    employeedocumentcreate: boolean = true
    employeedocumentupdate: boolean = true
    employeerelationshipcreate: boolean = true
    employeerelationshipupdate: boolean = true
}



 export class ClientSupportRelationShipBO {
    supportPlannerId: string;
    activeDate: string | null;
    inActiveDate: string | null;
    clientId: string;
    id: string="00000000-0000-0000-0000-000000000000";
}


export class getMappedSupportPlannerBO extends GetListBase {
    id: string;
    supportPlannerId: string;
    clientId: string;
    name: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    email: string;
    fax: string;
    phone: string;
    statusLid: string;
    statusName: string;
    activeDate: string;
    inActiveDate: string | null;
}



export class returnSupportPlannerBO {
    totalCount: number;
    listcli: getMappedSupportPlannerBO[];
}




export class GetClientEvaluation {
    orderColumn: string="supportPlannerName";
    orderType: string="asc";
    pageitem: number=10;
    clientId: string;
    ages: number | null;
    client: string;
    currentpageno: number=1;
    field: string="supportPlannerName";
    value: string="";
    matchCase: boolean=false;
    type: string="string";
     operator: string = "startswith";
    employeeID: string | null;
    vendorId: string | null;
    relationshipFilter: string | null;
    agency: string | null;
    state: string;
    onboardId: string | null;






}